var _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteUserImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_67_6",
    "data-name": "Component 67 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 87,
    viewBox: "0 0 120 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4338",
    "data-name": "Rectangle 4338",
    width: 97,
    height: 73,
    rx: 22,
    fill: "#ff7c49"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8740",
    "data-name": "Group 8740",
    transform: "translate(21.843 8.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5233",
    "data-name": "Group 5233",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5232",
    "data-name": "Group 5232",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M370.833,846.026c1.137,5.685,2.275,13.319,2.275,13.319s-4.385,3.9-25.014,3.9h-2.787c-20.627,0-25.013-3.9-25.013-3.9s1.137-7.634,2.274-13.319,16.567-10.233,16.567-10.233v-.578c-.058-.292.118-.521.442-.7,0,0,1.78,6.144,7.354,6.144s7.546-6.144,7.546-6.144c.324.179.5.407.44.7l-.261.691S369.7,840.341,370.833,846.026Z",
    transform: "translate(-320.294 -807.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    "data-name": "Path 3383",
    d: "M383.062,794.685s1.556.456,1.184,1.672-2.158,4.555-2.645,4.555h-.488l-1.166,2.43s-2.57,3.8-5.818,4.4h-.258c-3.248-.607-5.818-4.4-5.818-4.4l-1.166-2.43H366.4c-.487,0-2.274-3.341-2.645-4.555s1.183-1.672,1.183-1.672a2.6,2.6,0,0,1-.154-.3,5.543,5.543,0,0,0,.619-.9,8.408,8.408,0,0,0,.416-.89c.117-.272.248-.539.39-.8a13.451,13.451,0,0,1,2.167-2.873,17.832,17.832,0,0,1,1.332-1.242q.347-.3.71-.571l.364-.27.1-.073.385.228q.329.187.664.362.67.35,1.359.651a23.379,23.379,0,0,0,2.831,1.026,21.559,21.559,0,0,0,2.948.637c.5.071,1,.122,1.5.155.252.014.5.028.756.033l.455.006,1.8,3.464A5.615,5.615,0,0,1,383.062,794.685Z",
    transform: "translate(-347.592 -777.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M384.3,769.359a31.257,31.257,0,0,1-.289,6.565l-1.535-2.958-.662,0-.359,0c-.24-.005-.479-.017-.717-.031-.478-.032-.955-.08-1.43-.149a20.2,20.2,0,0,1-2.813-.608,21.9,21.9,0,0,1-2.712-.983q-.662-.289-1.3-.621c-.213-.111-.424-.226-.63-.344l-.308-.181-.257-.16-.311-.207-.387.253-.279.2-.387.286q-.383.291-.749.6-.732.62-1.4,1.309a14.412,14.412,0,0,0-2.32,3.085q-.234.429-.43.881a7.535,7.535,0,0,1-.373.8c-.048.086-.1.168-.153.252a26.325,26.325,0,0,1-.6-7.99c.325-7.138,8.608-7.9,8.608-7.9h3.182S383.97,762.221,384.3,769.359Z",
    transform: "translate(-347.688 -761.462)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon_navigation_close_24px",
    "data-name": "icon/navigation/close_24px",
    transform: "translate(65 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4339",
    "data-name": "Rectangle 4339",
    fill: "#f6f6f6",
    stroke: "#545454",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 43,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 53,
    height: 41,
    rx: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 33,
    height: 33,
    transform: "translate(5 5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M20.364,2.051,18.313,0,10.182,8.131,2.051,0,0,2.051l8.131,8.131L0,18.313l2.051,2.051,8.131-8.131,8.131,8.131,2.051-2.051-8.131-8.131Z",
    transform: "translate(27.5 7.101) rotate(45)",
    fill: "#787878"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUserImage);
export default __webpack_public_path__ + "static/media/InviteUserImage.ba2ca36c2eb2c3e99a986979d84227dc.svg";
export { ForwardRef as ReactComponent };